import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SmartintegService } from '../../../../services/smartinteg.service';
import { ToastService } from '../../../../services/toast.service';
import { Processo } from '../../../../types/smartinteg';

@Component({
  selector: 'app-processo-form',
  templateUrl: './processo-form.component.html',
  styleUrls: ['./processo-form.component.css']
})
export class ProcessoFormComponent implements OnInit {

  form!: FormGroup;
  loading: boolean = false;
  isEditMode: boolean = false;
  processoId?: string;

  constructor(
    private fb: FormBuilder,
    private smartintegService: SmartintegService,
    private toastService: ToastService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.inicializarFormulario();
    this.verificarModoEdicao();
  }

  inicializarFormulario(): void {
    this.form = this.fb.group({
      nome: ['', [Validators.required, Validators.minLength(3)]],
      descricao: ['', Validators.required]
    });
  }

  verificarModoEdicao(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.isEditMode = true;
        this.processoId = params['id'];
        if (this.processoId) {
          this.carregarProcesso(this.processoId);
        }
      }
    });
  }

  carregarProcesso(id: string): void {
    this.loading = true;
    this.smartintegService.buscarProcesso(id).subscribe({
      next: (processo) => {
        this.form.patchValue(processo);
        this.loading = false;
      },
      error: (error) => {
        this.toastService.erro('Erro', 'Erro ao carregar processo: ' + error.error?.message);
        this.loading = false;
        this.voltar();
      }
    });
  }

  salvar(): void {
    if (this.form.invalid) {
      this.toastService.alerta('Atenção', 'Preencha todos os campos obrigatórios');
      this.marcarCamposComoTocados();
      return;
    }

    this.loading = true;
    const processoData = { ...this.form.value, id: this.processoId };

    const action = this.isEditMode 
      ? this.smartintegService.atualizarProcesso(processoData)
      : this.smartintegService.criarProcesso(processoData);
    
    const message = this.isEditMode ? 'atualizado' : 'criado';

    action.subscribe({
      next: () => {
        this.toastService.sucesso('Sucesso', `Processo ${message} com sucesso`);
        this.loading = false;
        this.voltar();
      },
      error: (error) => {
        this.toastService.erro('Erro', `Erro ao ${this.isEditMode ? 'atualizar' : 'criar'} processo: ` + error.error?.message);
        this.loading = false;
      }
    });
  }

  marcarCamposComoTocados(): void {
    Object.values(this.form.controls).forEach(control => control.markAsTouched());
  }

  campoInvalido(campo: string): boolean {
    const control = this.form.get(campo);
    return !!(control && control.invalid && control.touched);
  }

  voltar(): void {
    this.router.navigate(['/smartinteg/processos']);
  }
}
